// SetupWasteWaterStoreProps

import { create } from "zustand";
import { getFilterTankEmissionControl, getFilterTankType, getTankEmissionControl, getTankType } from "src/services/settings.service";
import { SetupWasteWaterStoreProps } from "./interface/setup-waste-water-store.interface";
import {
  createSetupWasteWater,
  deleteSetupWasteWater,
  getAllSettingWasteWater,
  getFilterColumnSetupWasteWater,
  getMasterDataEmission,
  getYearSetupWasteWater,
  searchSetupWasteWater,
  updateSetupWasteWater,
} from "src/services/waste-water.service";
import { CreateSetupWasteWater, FilterSetupWasteWater, UpdateSetupWasteWaterDto } from "src/entity/waste-water/setup-information.entity";

export const setupWasteWaterStore = create<SetupWasteWaterStoreProps>((set) => ({
  loadingGetMaster: false,
  loadingManageWasteWater: false,
  loadingWasteWater: false,
  dataWasteWater: {
    data: [],
    total: 0,
  },
  errorWasteWater: null,
  filterWasteWater: {
    wasteWaterUnit: [],
    area: [],
    emissionControl: [],
    efficiency: [],
    controlExceptionDate: [],
  },
  dataSettingWasteWater: [],
  dataYear: [],
  dataMasterEmissionObject: [],
  getMasterEmissionObject: async () => {
    try {
      const response = await getMasterDataEmission();
      set(() => ({ dataMasterEmissionObject: response.data?.data || [] }));
    } catch (error) {
      console.log();
    }
  },
  clearError: (type: string) => {
    set(() => ({ [`${type}`]: null }));
  },
  setError: (type: string, value: string) => {
    set(() => ({ [`${type}`]: value }));
  },
  getYearSetupWasteWater: async () => {
    try {
      const currentYear = new Date().getFullYear();
      const response = await getYearSetupWasteWater();

      set(() => ({ dataYear: response.data?.data && response.data.data.length == 0 ? [currentYear.toString()] : response.data.data }));
    } catch (error) {
      console.log();
    }
  },

  // Setup Waste Water Information ZONE !
  createSetupWasteWater: async (body: CreateSetupWasteWater) => {
    set(() => ({ loadingManageWasteWater: true }));
    try {
      const res = await createSetupWasteWater(body);
      set(() => ({ loadingManageWasteWater: false }));
      return res.data?.data;
    } catch (err: any) {
      const message = err?.response?.data?.message || err?.message;
      set(() => ({ loadingManageWasteWater: false, errorWasteWater: message }));
      return message;
    }
  },
  updateSetupWasteWater: async (body: UpdateSetupWasteWaterDto) => {
    set(() => ({ loadingManageWasteWater: true }));
    try {
      await updateSetupWasteWater(body);
      set(() => ({ loadingManageWasteWater: false }));
    } catch (err: any) {
      const message = err?.response?.data?.message || err?.message;
      set(() => ({ loadingManageWasteWater: false, errorWasteWater: message }));
      return message;
    }
  },
  deleteSetupWasteWater: async (id: string) => {
    set(() => ({ loadingManageWasteWater: true }));
    try {
      const res = await deleteSetupWasteWater(id);
      set(() => ({ loadingManageWasteWater: false }));
    } catch (err: any) {
      set(() => ({ loadingManageWasteWater: false, errorWasteWater: err?.message }));
    }
  },
  searchSetupWasteWater: async (filter: FilterSetupWasteWater) => {
    set(() => ({ loadingWasteWater: true }));
    try {
      const res = await searchSetupWasteWater(filter);
      set(() => ({ loadingWasteWater: false, dataWasteWater: res.data?.data }));
    } catch (err: any) {
      set(() => ({ loadingWasteWater: false, error: err?.message, dataWasteWater: { data: [], total: 0 } }));
    }
  },
  getFilterColumnSetupWasteWater: async (year: string) => {
    set(() => ({ loadingGetMaster: true }));
    try {
      const res = await getFilterColumnSetupWasteWater({ year });
      set(() => ({
        loadingGetMaster: false,
        filterWasteWater: res.data?.data,
      }));
    } catch (err: any) {
      set((state) => ({
        loadingGetMaster: false,
        filterWasteWater: {
          ...state.filterWasteWater,
        },
      }));
    }
  },
  getAllSettingWasteWater: async () => {
    set(() => ({ loadingGetMaster: true }));
    try {
      const response = await getAllSettingWasteWater({ isActive: true });

      set(() => ({ loadingGetMaster: false, dataSettingWasteWater: response.data?.data ?? [] }));
    } catch (error) {
      console.log();
    } finally {
      set(() => ({ loadingGetMaster: false }));
    }
  },
}));
